// ADR-038 D6 + D13. PKCE redirect flow against Bekaert Entra tenant.
// Audience = rag-api's Entra app client_id (prefixed `api://`).

import type { Configuration } from "@azure/msal-browser";
import { appConfig } from "@/env";

// Read at module-eval time from runtime config (window.__APP_CONFIG__) with a
// VITE_ build fallback. All three values are public (RFC 6749 §2.2).
const tenantId = appConfig("ENTRA_TENANT_ID");
const clientId = appConfig("ENTRA_CLIENT_ID");
const apiAudience = appConfig("API_AUDIENCE");

if (!tenantId || !clientId || !apiAudience) {
  // Surface misconfig early; bare 401s are confusing to debug.
  console.warn("[chat-ui] MSAL env not fully set: VITE_ENTRA_TENANT_ID / VITE_ENTRA_CLIENT_ID / VITE_API_AUDIENCE");
}

// MSAL v5 redirect bridge target. Built from `redirect.html` (project
// root) via the multi-page Vite config. Mirror of admin-ui — see
// services/admin-ui/src/auth/msalConfig.ts for the full rationale.
const REDIRECT_BRIDGE_PATH = "/redirect.html";

export const msalConfig: Configuration = {
  auth: {
    clientId: clientId ?? "",
    authority: `https://login.microsoftonline.com/${tenantId ?? "common"}`,
    redirectUri: `${window.location.origin}${REDIRECT_BRIDGE_PATH}`,
    postLogoutRedirectUri: window.location.origin,
  },
  cache: {
    cacheLocation: "sessionStorage",
  },
  system: {
    loggerOptions: {
      loggerCallback: () => undefined,
      logLevel: 0, // LogLevel.Error
      piiLoggingEnabled: false,
    },
  },
};

// Scope for our backend API.
export const apiScopes = [`${apiAudience}/access_as_user`];

// Login request — OAuth scopes for getting an ID token at sign-in.
export const loginRequest = {
  scopes: ["openid", "profile", "email", ...apiScopes],
};
